module.exports = __webpack_public_path__ + "static/media/Stilt-Kin-Selected.93c2e637.png";